import React from 'react';
import FooterPage from '../../shared/components/footer/footer.container';
import { useHistory, useLocation } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import { Button } from 'app-template-lib/components/shadcn';

/**
 * 3カラムレイアウト　テンプレートファイル
 * @param param0
 * @returns
 */
export default function ColumnLayout({ children }: { children: React.ReactNode }) {
    const location = useLocation();
    const pathnames = location.pathname.split('/');
    const hostpath = pathnames[1];
    const history = useHistory();
    return (
        <>
            {/* メインコンテンツ*/}
            <div className="flex flex-col min-h-screen">
                <main className="flex-grow overflow-auto">
                    <div className="container mx-auto  grid grid-cols-1 md:grid-cols-[2fr_8fr_2fr] gap-6">
                        {/* 左側の空コンテンツ */}
                        <section></section>

                        {/* 中央のコンテンツ表示エリア */}
                        <section>
                            {hostpath !== 'toppage' && (
                                <div className="flex mb-2 mt-1">
                                    <Button onClick={() => history.goBack()} className="text-primary pl-1 bg-background" variant="link">
                                        <ChevronLeft />
                                        戻る
                                    </Button>
                                </div>
                            )}
                            {children}
                        </section>

                        {/* 右側の空コンテンツ */}
                        <section></section>
                    </div>
                </main>
                <footer>
                    <FooterPage />
                </footer>
            </div>
        </>
    );
}
